import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { register } from 'swiper/element/bundle';
import { Router, NavigationEnd } from '@angular/router';
import { filter, take } from 'rxjs/operators';

// ⬇️ Register Swiper custom elements globally
register();

/**
 * Remove the initial page-load loader once Angular is bootstrapped
 * and the first route is rendered.
 */
function removeInitialLoader() {
  const loaderWrapper = document.getElementById('initial-loader-wrapper');
  if (loaderWrapper) {
    // Add hide class to fade out (transition defined in HTML style tag)
    loaderWrapper.classList.add('hide');
    // Remove from DOM after transition completes to free memory
    setTimeout(() => {
      loaderWrapper.remove();
    }, 600); // Match the transition duration in CSS
  }
}

bootstrapApplication(App, appConfig)
  .then((appRef) => {
    // Get the Router from the app's injector
    const router = appRef.injector.get(Router);

    // Remove loader on first successful navigation
    router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      take(1)
    ).subscribe(() => {
      removeInitialLoader();
    });

    // Safety fallback: remove loader if routing takes too long
    // (in case app gets stuck or redirects to error page)
    setTimeout(() => {
      const loaderWrapper = document.getElementById('initial-loader-wrapper');
      if (loaderWrapper) {
        removeInitialLoader();
      }
    }, 10000); // 10 second safety timeout
  })
  .catch((err) => {
    console.error(err);
    // Remove loader even on error to prevent it from staying on screen forever
    removeInitialLoader();
  });
